import { convertMMToCM, convertMMToInches, convertMMToPX } from "./UnitConverter.mjs";
export class SizeConverter {
    constructor(item, mm = 0) {
        this.item = item;
        this.mm = mm;
    }
    /**
     * Get the measurement value in inches.
     *
     * @returns The measurement value converted to inches.
     */
    get inches() {
        return convertMMToInches(this.mm);
    }
    /**
     * Get the measurement value in centimeters.
     *
     * @returns The measurement value converted to centimeters.
     */
    get cm() {
        return convertMMToCM(this.mm);
    }
    /**
     * Get the measurement value in pixels.
     *
     * @returns The measurement value converted to pixels.
     */
    get px() {
        return convertMMToPX(this.mm);
    }
    /**
     * Get the measurement value in the localized unit (inches or centimeters).
     *
     * @returns The measurement value converted to the localized unit.
     */
    get localized() {
        var _a;
        return ((_a = this.item.getAttribute('imperial_units')) === null || _a === void 0 ? void 0 : _a.toString()) === 'true' ? this.inches : this.cm;
    }
    toObject() {
        return {
            mm: this.mm,
            inches: this.inches,
            cm: this.cm,
            px: this.px,
            localized: this.localized,
        };
    }
}
